import React, { ReactNode } from "react";
import { Drawer, Modal } from "antd";
import SheetHeaderClose from "../../v2/components/SheetHeaderClose";

interface Props {
  open: boolean;
  onClose: () => void;
  title: ReactNode;
  isMobile: boolean;
  width?: number;
  children: ReactNode;
}

// Shared "view all" popup pattern used across the page's 4 modals: a Modal on
// desktop, a bottom Drawer on mobile - mirrors pages/gd/v2/components/FiltersPanel.
export default function GroundTourModal({ open, onClose, title, isMobile, width = 560, children }: Props) {
  if (isMobile) {
    return (
      <Drawer
        open={open}
        onClose={onClose}
        placement="bottom"
        height="auto"
        title={title}
        closable={false}
        extra={<SheetHeaderClose onClose={onClose} />}
        rootClassName="v2-sheet ground-tour-show-v2__sheet"
      >
        {children}
      </Drawer>
    );
  }

  return (
    <Modal
      open={open}
      onCancel={onClose}
      title={title}
      width={width}
      centered
      footer={null}
      rootClassName="ground-tour-show-v2__modal"
    >
      {children}
    </Modal>
  );
}
